import { initializeApp } from 'firebase/app';
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendEmailVerification,
  sendPasswordResetEmail,
} from 'firebase/auth';
import { log } from './api-client.ts';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

// 認証周り
const auth = getAuth(app);

export type LogInProps = {
  email: string;
  password: string;
};

const safeLog = async (name: string, data?: Record<string, string>) => {
  try {
    await log(name, data);
  } catch (e) {
    console.error(`Failed to send auth log: ${name}`, e);
  }
};

const signUp = async ({ email, password }: LogInProps) => {
  await createUserWithEmailAndPassword(auth, email, password);
  await verify();
  // await login({email, password})
};

const verify = async () => {
  const user = auth.currentUser!;
  await sendEmailVerification(user);
  void safeLog('sitter-send-email-verify', {
    email: user.email || '',
    uid: user.uid,
  });
};

const login = async (props: LogInProps) => {
  const credential = await signInWithEmailAndPassword(auth, props.email, props.password);
  void safeLog('sitter-login', {
    email: props.email,
    uid: credential.user.uid,
  });
  return credential;
};

const logout = async () => {
  void safeLog('sitter-logout', { uid: auth.currentUser?.uid || '' });
  return await signOut(auth);
};

const reset = async (email: string) => {
  await sendPasswordResetEmail(auth, email);
  void safeLog('sitter-reset-password', { email });
};

export { auth, signUp, login, logout, verify, reset };
